import "./player.css"

export function init(ui: HTMLDivElement, backFn: () => void, forwardFn: () => void, playFn: () => void, pauseFn: () => void) {
    if (!ui) {
        console.warn("no UI for player set")
    }
    const author = ui.querySelector(".author") as HTMLDivElement
    const play = ui.querySelector(".play") as HTMLButtonElement
    const pause = ui.querySelector(".pause") as HTMLButtonElement
    const back = ui.querySelector(".back") as HTMLButtonElement
    const fwd = ui.querySelector(".forward") as HTMLButtonElement

    if (!author) {
        console.warn("no author element found in play ui")
    }
    if (!play) {
        console.warn("no play button found in play ui")
    }
    if (!back) {
        console.warn("no back button found in play ui")
    }
    if (!fwd) {
        console.warn("no back button found in play ui")
    }

    back?.addEventListener("click", backFn)
    play?.addEventListener("click", playFn)
    fwd?.addEventListener("click", forwardFn)
    pause?.addEventListener("click", pauseFn)

    return {
        disable: (disable: boolean) => {
            play.disabled = disable
            back.disabled = disable
            fwd.disabled = disable
            if (pause) {
                pause.disabled = disable
                pause.style.visibility = "hidden"
            }
            author.innerText = ""
        },
        enablePlay(b: boolean) {
            play.disabled = !b
        },
        enableBack(b: boolean) {
            back.disabled = !b
        },
        enableFwd(b: boolean) {
            fwd.disabled = !b
        },
        displayAuthor(rec: Recording | string) {
            if (typeof rec === "string")
                author.innerText = rec
            else {
                if (rec.author?.trim().length > 0)
                    author && (author.innerText = rec.author ?? "anonymous")
                else
                    author && (author.innerText = rec.id.toString())
            }
        },
        enablePauseIfAvailable(b: boolean) {
            if (pause) {
                play.style.visibility = b ? "hidden" : "visible"
                pause.disabled = !b
                pause.style.visibility = b ? "visible" : "hidden"
            }
        }
    }
}
